import script from "./Collapsible.vue?vue&type=script&setup=true&lang=js"
export * from "./Collapsible.vue?vue&type=script&setup=true&lang=js"

import "./Collapsible.vue?vue&type=style&index=0&id=50954709&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50954709"]])

export default __exports__